import { StubScreen } from '../StubScreen';

// Stub (DIT-671). Real content lands in DIT-684 (3.2 founding-date).
export const FoundingDateScreen = () => (
  <StubScreen id="founding-date" heading="Wann wurde Ihre Firma gegründet?" />
);
